var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homenav"},[_c('van-grid',{staticClass:"shadow-sm",attrs:{"icon-size":"60","border":false}},_vm._l((_vm.navList),function(item,index){return _c('van-grid-item',{key:'nav' + index,attrs:{"icon":item.img,"text":item.name},on:{"click":function($event){return _vm.$push(item.url)}}})}),1),_c('div',{staticClass:"saizi"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }